import React from 'react'
import { Box, Tooltip, Typography } from '@mui/material'

type AdoptionStatus = 'Unknown' | 'None' | 'Partial' | 'Full'

interface AdoptionIndicatorProps {
  status: string | null
  note?: string | null
}

const AdoptionIndicator: React.FC<AdoptionIndicatorProps> = ({ status, note }) => {
  const adoptionStatus: AdoptionStatus = (status === 'None' || status === 'Partial' || status === 'Full') ? status : 'Unknown'

  const statusConfig: Record<AdoptionStatus, { filled: number; color: string }> = {
    Unknown: { filled: 0, color: '#bdbdbd' },
    None:    { filled: 1, color: '#ef5350' },
    Partial: { filled: 2, color: '#ff9800' },
    Full:    { filled: 3, color: '#4caf50' },
  }

  const { filled, color } = statusConfig[adoptionStatus]

  return (
    <Tooltip
      title={
        <Box>
          <Typography variant="body2" sx={{ fontWeight: 600 }}>Adoption: {adoptionStatus}</Typography>
          {note && <Typography variant="caption">{note}</Typography>}
        </Box>
      }
      arrow
      placement="top"
    >
      <Box sx={{ display: 'flex', gap: 0.3, cursor: 'help' }}>
        {[0, 1, 2].map(i => (
          <Box
            key={i}
            sx={{
              width: 8,
              height: 8,
              borderRadius: '50%',
              bgcolor: i < filled ? color : 'transparent',
              border: `1.5px solid ${color}`
            }}
          />
        ))}
      </Box>
    </Tooltip>
  )
}

export default AdoptionIndicator
